import SpeedIcon from '@material-ui/icons/Speed';
import PermDataSettingIcon from '@material-ui/icons/PermDataSetting';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import TuneIcon from '@material-ui/icons/Tune';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import SyncDisabledIcon from '@material-ui/icons/SyncDisabled';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import WifiIcon from '@material-ui/icons/Wifi';
import SignalCellular3BarIcon from '@material-ui/icons/SignalCellular3Bar';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';
import BatteryCharging90Icon from '@material-ui/icons/BatteryCharging90';
import WifiOffIcon from '@material-ui/icons/WifiOff';
import AirplanemodeActiveIcon from '@material-ui/icons/AirplanemodeActive';
import SignalCellularConnectedNoInternet1BarIcon from '@material-ui/icons/SignalCellularConnectedNoInternet1Bar';
import CloudIcon from '@material-ui/icons/Cloud';

import { navigatorDetails } from 'UTILS/navigator';

const getOSNetworkImprovement = ({ os }) => {
  switch (os) {
    case 'iOS':
    case 'Android':
      return {
        icon: SignalCellular3BarIcon,
        title: 'lookForBetterSignal',
        text: 'ifYouAreUsingMobileDataToConnectToTheInternetMoveAroundToFindASpotWithABetterConnection',
      };
    default:
      return {
        icon: SettingsEthernetIcon,
        title: 'preferEthernet',
        text: 'ifYouAreUsingWifiToConnectToTheInternetTryToUseAnEthernetCableConnectionInstead-theEthernetCableShouldBeConnectedToYourRouter',
      };
  }
};

export const getConnectionImprovementHintList = ({ os = navigatorDetails.os } = {}) => ([
  {
    icon: WifiIcon,
    title: 'getCloserToWifi',
    text: 'ifYouAreUsingWifiToConnectToTheInternetTryGettingCloserToYourRouter',
  },
  getOSNetworkImprovement({ os }),
  {
    icon: CloudIcon,
    title: 'stopDownloading',
    text: 'ifYouAreDownloadingOrUploadingHeavyDataYourCallQualityWillDecline',
  },
  {
    icon: BatteryCharging90Icon,
    title: 'chargeYourDevice',
    text: 'theBatteryLevelOfYourDeviceHasABigImpactOnTheQualityOfTheConnection-chargeYourDeviceAndRunTheTestLater',
  },
]);

export const getNoConnectionHintList = ({ os = navigatorDetails.os } = {}) => {
  switch (os) {
    case 'iOS':
    case 'Android':
      return [
        {
          icon: AirplanemodeActiveIcon,
          title: 'disableAirPlaneMode',
          text: 'checkThatTheAirplaneModeIsNotEnabledOnYourDevice',
        },
        {
          icon: WifiOffIcon,
          title: 'enableWifi',
          text: 'ifYouPlanOnUsingAWifiConnectionCheckThatItIsEnabledAndConnectedToTheRightNetwork',
        },
        {
          icon: SignalCellularConnectedNoInternet1BarIcon,
          title: 'enableMobileData',
          text: 'ifYouPlanOnUsingAMobileDataConnectionCheckThatItIsEnabledAndThatTheSignalIsGood',
        },
      ];
    default:
      return [
        {
          icon: WifiOffIcon,
          title: 'enableWifi',
          text: 'ifYouPlanOnUsingAWifiConnectionCheckThatItIsEnabledAndConnectedToTheRightNetwork',
        },
        {
          icon: SettingsEthernetIcon,
          title: 'connectAnEthernetCable',
          text: 'ifYouPlanOnUsingACableConnectionCheckThatTheEthernetCableIsConnectedToYourRouter',
        },
      ];
  }
};

export const CONNECTIVITY_RESULT_MAP = {
  'no_network_connection': {
    message: 'youAreNotConnectedToTheLocalNetwork',
    title: 'whatCanIDoAboutIt',
    hintList: getNoConnectionHintList(),
  },
  'udp_not_supported': {
    message: 'udpProtocolNotSupported',
    title: 'whatCanIDoAboutIt',
    hintList: [
      {
        icon: SpeedIcon,
        title: 'poorQualityCall',
        text: 'UDPIsTheBestFastestProtocolForRealTimeCommunication-withoutItYourCallsWillProbablyBeOfAPoorerQuality',
      },
      {
        icon: TuneIcon,
        title: 'checkTheNetworkSettings',
        text: 'ifYouAreInAnInstitutionAskTheITDeptTheyMayHaveAddedSecuritySettingsToYourDeviceOrNetworkThatBlockUDPProtocol',
      },
      {
        icon: PermDataSettingIcon,
        title: 'connectToAnotherNetwork',
        text: 'ifYouCanTryUsingAnotherNetwork-forInstanceMobile4GSharingCanBeAGoodWorkAround',
      },
    ],
  },
  'relay_access_impossible': {
    message: 'relayAccessIsImpossible',
    title: 'whatCanIDoAboutIt',
    hintList: [
      {
        icon: VisibilityOffIcon,
        title: 'recipientsMayBeUnreachable',
        text: 'theRelayIsUsedToEnsureThatACommunicationCanBeEstablishedWithYourRecipientsDespiteComplexNetworkConfigurations-youMightNotBeAbleToCommunicateWithYourRecipientsIfYouCantAccessTheRelay',
      },
      {
        icon: TuneIcon,
        title: 'checkTheNetworkSettings',
        text: 'ifYouAreInAnInstitutionAskTheITDeptTheyMayHaveAddedSecuritySettingsToYourDeviceOrNetworkThatBlockAccessToTheRelay',
      },
      {
        icon: PermDataSettingIcon,
        title: 'connectToAnotherNetwork',
        text: 'ifYouCanTryUsingAnotherNetwork-forInstanceMobile4GSharingCanBeAGoodWorkAround',
      },
    ],
  },
  'indirect_connection': {
    message: 'directConnectionIsImpossible',
    title: 'whatCanIDoAboutIt',
    hintList: [
      {
        icon: DeviceHubIcon,
        title: 'youDependOnTheRelay',
        text: 'yourNetworkConfigurationIsComplex-yourCommunicationsWillBeRelayedByAServer-youShouldBeFineAsLongAsThatRelayServerRemainsReachableByYourNetwork',
      },
    ],
  },
  'indirect_connection_relay_access_impossible': {
    message: 'communicationsCantBeEstablished',
    title: 'whatCanIDoAboutIt',
    hintList: [
      {
        icon: SyncDisabledIcon,
        title: 'yourComplexNetworkCantAccessTheRelay',
        text: 'yourNetworkConfigurationIsComplexAndRequiresAnAccessToTheRelayServerToPerformVideoConferencesButItIsOutOfReach',
      },
      {
        icon: TuneIcon,
        title: 'checkTheNetworkSettings',
        text: 'ifYouAreInAnInstitutionAskTheITDeptTheyMayHaveAddedSecuritySettingsToYourDeviceOrNetworkThatBlockAccessToTheRelay',
      },
      {
        icon: PermDataSettingIcon,
        title: 'connectToAnotherNetwork',
        text: 'ifYouCanTryUsingAnotherNetwork-forInstanceMobile4GSharingCanBeAGoodWorkAround',
      },
    ],
  },
  'connectivity_check_impossible': {
    message: 'someChecksCouldNotBePerformed',
    title: 'whatCanIDoAboutIt',
    hintList: [
      {
        icon: WatchLaterIcon,
        title: 'tryAgainLater',
        text: 'weAreProbablyAlreadyWorkingOnFixingThisIssueTryAgainLater-ifYouAreInAnInstitutionAndTheProblemRemainsTellAnAdmin',
      },
      {
        icon: SkipNextIcon,
        title: 'skipTheTest',
        text: 'thereIsAChanceThatYouCanStillPerformVideoConferences-ifTheOtherSuggestionsDidNotWorkYouCanSkipThisCheckAndHopeItWillWorkDuringTheVideoConference',
      },
    ],
  },
  'very_bad_connection': {
    message: 'yourConnectionIsNotGoodEnough',
    title: 'howCanIImproveMyConnection',
    hintList: getConnectionImprovementHintList(),
  },
  'bad_connection': {
    message: 'yourConnectionCouldBeBetter',
    title: 'howCanIImproveMyConnection',
    hintList: getConnectionImprovementHintList(),
  },
  'good_connection': {
    message: 'yourConnectionIsGood',
  },
};
